import sha512 from 'crypto-js/sha512';
import sha256 from 'crypto-js/sha256';

import hmacSHA512 from 'crypto-js/hmac-sha512';

export default class CryptoUtils {

    public static SHA512Digest(message: string): string {
        return sha512(message).toString();
    }

    public static SHA256(message: string): string {
        return sha256(message).toString();
    }

    public static HMAC512Digest(string1: string, string2: string): string {
        return hmacSHA512(string1, string2).toString()
    }

}